module.exports = "https://static.wagwalking.com/_next/static/images/pet-3-b4e9e5bf4a325a1aedfbf6f4867257c4.png";